module.exports = __webpack_public_path__ + "img/icon_ws.9413ab16.png";